import * as actions from '../../redux/actions';

import { KuposButton, KuposInput } from '../../../common';

import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getFonts from '../../functions/getFonts';
import getIcons from '../../functions/getIcons/getIcons';

const ContactForm3 = ({ operator, id }) => {
	return (
		<div id={id} className="themes-contact-form-3">
			<div className="new-container">
				<div
					className={`${getFonts('bold')} themes-contact-form-3-header mb-3`}
					style={{
						color:
							operator && operator.color_codes && operator.color_codes.secondary_color
								? operator.color_codes.secondary_color
								: '',
					}}
				>
					<h2>
						Contacto
						<img src={getIcons('Line', operator)} alt="" />
					</h2>
				</div>
				<div className="themes-contact-form-3-main">
					<div
						className={`${getFonts('bold')} themes-contact-form-3-info`}
						style={{
							color:
								operator && operator.color_codes && operator.color_codes.tertiary_color
									? operator.color_codes.tertiary_color
									: '',
						}}
					>
						{operator.phone_number && (
							<div className="themes-contact-form-3-info-item">
								<img src={getIcons('Headphone', operator)} alt="" />
								<span>Teléfono: {operator.phone_number}</span>
							</div>
						)}

						{operator.phone_number && (
							<div className="themes-contact-form-3-info-item">
								<img src={getIcons('Whatsapp', operator)} alt="" />
								<span>{operator.phone_number}</span>
							</div>
						)}

						{operator.email && (
							<div className="themes-contact-form-3-info-item">
								<img src={getIcons('Email', operator)} alt="" />
								<span>Email: {operator.email}</span>
							</div>
						)}
					</div>
					<div
						className={`${getFonts('bold')} themes-contact-form-3-form`}
						style={{
							background:
								operator && operator.color_codes && operator.color_codes.secondary_color
									? operator.color_codes.secondary_color
									: '',
						}}
					>
						<div className="themes-contact-form-3-form-inputs">
							<div className="contact-input-item">
								<div className="contact-input-label font11">Nombre</div>
								<KuposInput type="text" placeholder="Nombre" />
							</div>

							<div className="contact-input-item mx-2">
								<div className="contact-input-label font12">Email</div>
								<KuposInput type="email" placeholder="Email" />
							</div>

							<div className="contact-input-item">
								<div className="contact-input-label font12">Nº de contacto</div>
								<KuposInput type="number" placeholder="Nº de contacto" />
							</div>
						</div>

						<div className="text-area-input mt-3">
							<div className="contact-input-label font12">Mensaje</div>
							<textarea className="text-area font12" rows={4} placeholder="Mensaje" />
						</div>

						<div className="contact-button  ">
							<KuposButton className="px-20">ENVIAR</KuposButton>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		themes: state.themes,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm3);



// WEBPACK FOOTER //
// ./src/features/themes/common/contact/ContactForm3.js